import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import './_apiDocsPanel.scss';

const ApiDocsPanel = ({ codeExamples }) => {
  const [activeTab, setActiveTab] = useState('curl');
  const [showAuthToken, setShowAuthToken] = useState(false);

  // Available programming language tabs
  const availableTabs = [
    { id: 'curl', name: 'curl' },
    { id: 'java', name: 'Java' },
    { id: 'ruby', name: 'Ruby' },
    { id: 'php', name: 'PHP' },
    { id: 'python', name: 'Python' },
    { id: 'csharp', name: 'C#' },
    { id: 'nodejs', name: 'Node.js' },
  ];

  const toggleAuthToken = () => {
    setShowAuthToken(!showAuthToken);
  };

  const handleCopyCode = (panel = 'request') => {
    let codeToCopy;

    if (panel === 'request') {
      const code = codeExamples[activeTab];
      codeToCopy = showAuthToken ? code : code.replace(/\[AuthToken\]/g, '********');
    } else {
      codeToCopy = codeExamples.response;
    }

    navigator.clipboard.writeText(codeToCopy);
  };

  const getDisplayCode = () => {
    return showAuthToken
      ? codeExamples[activeTab]
      : codeExamples[activeTab].replace(/\[AuthToken\]/g, '********');
  };

  return (
    <div className="api-docs-container">
      <div className="api-docs-panel">
        <div className="api-docs-tabs">
          {/* Request/Response toggle */}
          <div className="tabs-section">
            <div className="request-tab active">
              <span>Request</span>
            </div>
          </div>

          {/* Programming language tabs */}
          <div className="language-tabs">
            {availableTabs.map((tab) => (
              <div
                key={tab.id}
                className={`language-tab ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.name}
              </div>
            ))}
          </div>
        </div>

        <div className="api-docs-content">
          <div className="api-docs-toolbar">
            <div className="auth-toggle" onClick={toggleAuthToken}>
              <i className="fas fa-key"></i>
              <span>Show auth token</span>
            </div>
            <div className="code-actions">
              <Button variant="link" className="copy-btn" onClick={handleCopyCode}>
                <i className="fas fa-copy"></i>
              </Button>
            </div>
          </div>

          <div className="api-code-block">
            <pre>
              <code>{getDisplayCode()}</code>
            </pre>
          </div>
        </div>
      </div>

      <div className="api-response-panel">
        <div className="api-response-header">
          <span>Response</span>
        </div>
        <div className="api-response-content">
          <div className="api-response-toolbar">
            <Button variant="link" className="copy-btn">
              <i className="fas fa-copy"></i>
            </Button>
          </div>
          <div className="api-response-block">
            <pre>
              <code>{codeExamples.response}</code>
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

ApiDocsPanel.propTypes = {
  codeExamples: PropTypes.object.isRequired,
};

export default ApiDocsPanel;
